import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import ExpensesAccountant from '../../../components/allExpense'
import './style.scss'
const ExpensesAllPage = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <ExpensesAccountant
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default ExpensesAllPage

/* BankReceiptIndex */